function formatNumberDisplay(n: number): string {
  // Display numbers with thousands separators
  return Number.isFinite(n) ? n.toLocaleString('en-GB') : String(n);
}

export function getAccessibleMiddle(middle: string): string {
  // If it's a rating like "4.7/5", read it as "4.7 out of 5"
  if (middle.includes('/')) {
    const [score, denom] = middle.split('/');
    const parsedScore = Number(score);

    return `${
      Number.isFinite(parsedScore) ? parsedScore : score
    } out of ${denom}`;
  }
  // Otherwise, treat as an integer count
  const parsed = Number(middle);

  return Number.isFinite(parsed) ? formatNumberDisplay(parsed) : middle;
}

export function getVisualMiddle(middle: string): string {
  // Keep "4.7/5" as-is, but add thousands separators for counts
  if (middle.includes('/')) {
    return middle;
  }

  const parsed = Number(middle);

  return Number.isFinite(parsed) ? formatNumberDisplay(parsed) : middle;
}
